<!-- input excel file -->
<!-- output array of array (if more than one sheet) and excel file (v-model) -->
<template>
  <span>
    <input
      ref="excel-upload-input"
      class="excel-upload-input"
      type="file"
      accept=".xlsx, .xls"
      @change="handleClick"
    />
    <button class="btn primary small" @click="handleUpload">
      {{ $t('config.profile.common.excelUploadButton') }}
    </button>
  </span>
</template>

<script>
import XLSX from 'xlsx'

export default {
  props: {
    value: {
      type: File,
      default: () => null
    }
  },
  data: function () {
    return {
      excelFile: this.value,

      excelData: {
        header: null,
        results: null
      },
      rows: []
    }
  },
  watch: {
    value(nv, ov) {
      this.excelFile = nv
    }
  },
  methods: {
    // util validate
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1

      if (isLt1M) {
        return true
      }

      this.$message({
        message: 'Please do not upload files larger than 1m in size.',
        type: 'warning'
      })
      return false
    },

    // handle event
    // generateData({ header, results }) {
    //   this.excelData.header = header
    //   this.excelData.results = results
    // },
    handleUpload() {
      this.$refs['excel-upload-input'].click()
    },
    handleClick(e) {
      const files = e.target.files
      this.excelFile = files[0]
      const rawFile = files[0] // only use files[0]
      if (!rawFile) return
      this.upload(rawFile)
    },
    upload(rawFile) {
      this.$refs['excel-upload-input'].value = null // fix can't select the same excel

      if (!this.beforeUpload) {
        this.readerData(rawFile)
        return
      }
      const before = this.beforeUpload(rawFile)
      if (before) {
        this.readerData(rawFile)
      }
    },
    readerData(rawFile) {
      // reset
      this.rows = []
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = e => {
          const data = e.target.result
          const workbook = XLSX.read(data, { type: 'array' })
          // console.log(workbook)
          for (const i of workbook.SheetNames.keys()) {
            const sheetName = workbook.SheetNames[i]
            const worksheet = workbook.Sheets[sheetName]
            // const header = this.getHeaderRow(worksheet)
            const results = XLSX.utils.sheet_to_json(worksheet)
            this.rows.push(results)
          }

          resolve()
        }
        reader.readAsArrayBuffer(rawFile)

        this.$emit('input', this.excelFile)
        this.$emit('output', this.rows)
      })
    },
    getHeaderRow(sheet) {
      const headers = []
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C
      const R = range.s.r
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) {
        /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
        /* find the cell in the first row */
        let hdr = 'UNKNOWN ' + C // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        headers.push(hdr)
      }
      return headers
    }
  }
}
</script>

<style scoped>
.excel-upload-input {
  display: none;
  z-index: -9999;
}
</style>
